/**
 * Cart drawer interactions — open/close, carousel, rebuild, qty, trending.
 */
(function ($) {
  var trendingSwiper = null;

  function isCartDrawerOpen() {
    var drawer = document.querySelector('.cd-drawer');
    return Boolean(drawer && drawer.classList.contains('expanded'));
  }

  function setCartDrawerOpenState(isOpen) {
    var $drawer = $('.cd-drawer');
    var $backdrop = $('.js-cart-drawer-backdrop');

    if (isOpen) {
      $drawer.addClass('expanded');
      $('body').addClass('sidecart-open').attr('data-cart-drawer-open', 'true');
      $backdrop.attr('aria-hidden', 'false');

      if (typeof disable_scrolling === 'function') {
        disable_scrolling();
      } else {
        $('html, body').css('overflow', 'hidden');
      }

      requestAnimationFrame(function () {
        initCdScrollbars('drawer-open');
      });

      return;
    }

    $drawer.removeClass('expanded');
    $('body').removeClass('sidecart-open').removeAttr('data-cart-drawer-open');
    $backdrop.attr('aria-hidden', 'true');

    if (typeof enable_scrolling === 'function') {
      enable_scrolling();
    } else {
      $('html, body').css('overflow', 'initial');
    }
  }

  function openSliderCart() {
    if (!$('.cd-drawer').length) {
      return;
    }

    if (typeof hide_quick_atc_modal === 'function') {
      hide_quick_atc_modal();
    }

    setCartDrawerOpenState(true);
    updateFreeShippingHtml();
  }

  function updateFreeShippingHtml() {
    var $slot = $('.cd-drawer .cd-shipping-slot');

    if (!$slot.length) {
      return;
    }

    return $.ajax({
      url: '/?section_id=cart-drawer-free-shipping',
      type: 'GET',
      cache: false,
    }).done(function (res) {
      var $parsed = $('<div>').append($.parseHTML(res));
      var $shipping = $parsed.find('.cd-shipping');

      if ($shipping.length) {
        $slot.html($shipping);
      } else {
        $slot.empty();
      }
    });
  }

  window.update_free_shipping_html = updateFreeShippingHtml;

  function closeSliderCart() {
    setCartDrawerOpenState(false);
  }

  function dlOpenCartDrawer(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();

      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    }

    var drawer = document.querySelector('.cd-drawer');

    if (!drawer) {
      var fallbackUrl = '/cart';
      window.location.href = fallbackUrl;
      return false;
    }

    openSliderCart();

    if (typeof window.rebuild_cart === 'function') {
      window.rebuild_cart();
    }

    return false;
  }

  window.open_slider_cart = openSliderCart;
  window.close_slider_cart = closeSliderCart;
  window.dlOpenCartDrawer = dlOpenCartDrawer;

  document.addEventListener('click', function (e) {
    if (!isCartDrawerOpen()) {
      return;
    }

    if (e.target.closest('.cd-drawer')) {
      return;
    }

    if (e.target.closest('.cart_part, .cart_icon, .js-open-cart-drawer')) {
      return;
    }

    if (e.target.closest('.quick_atc_content_wrapper')) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    closeSliderCart();
  }, true);

  document.addEventListener('click', function (e) {
    var cartTrigger = e.target.closest(
      '.cart_part, .cart_icon, .js-open-cart-drawer'
    );

    if (!cartTrigger) {
      return;
    }

    dlOpenCartDrawer(e);
  }, true);

  $(document).on('click', '.js-cart-drawer-backdrop', function (e) {
    e.preventDefault();
    closeSliderCart();
  });

  function syncCartDrawerOpenState() {
    var drawer = document.querySelector('.cd-drawer');

    if (!drawer) {
      return;
    }

    var isOpen = drawer.classList.contains('expanded');
    var bodyIsOpen = document.body.classList.contains('sidecart-open');

    if (isOpen !== bodyIsOpen) {
      setCartDrawerOpenState(isOpen);
    }
  }

  function watchCartDrawerState() {
    var drawer = document.querySelector('.cd-drawer');

    if (!drawer || typeof MutationObserver === 'undefined') {
      return;
    }

    var observer = new MutationObserver(syncCartDrawerOpenState);

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function syncCartDrawerCount(count) {
    if (count === '' || count === null || typeof count === 'undefined') {
      return;
    }

    $('.js-cart-drawer-count').text(count);
    $('span[cart-item-count]').text(count);
  }

  function syncCartCountFromApi() {
    return $.getJSON('/cart.js').done(function (cart) {
      syncCartDrawerCount(cart.item_count);
    });
  }

  function resetDrawerItemsHeight() {
    $('.cd-drawer .js-cd-items').css({ height: 'auto' });
  }

  var cdScrollbarRefreshTimers = [];
  var cdScrollbarMutationObserver = null;
  var cdScrollbarSyncToken = 0;

  /**
   * Sync custom scrollbar thumb size/position for a cart body element.
   * @param {HTMLElement} body
   * @param {string} [reason]
   */
  function syncCdScrollbar(body, reason) {
    if (!body || !body.isConnected) {
      return;
    }

    var scroll = body.closest('.cd-scroll');
    var track = scroll
      ? scroll.querySelector('.js-cd-scrollbar')
      : null;
    var thumb = track
      ? track.querySelector('.js-cd-scrollbar-thumb')
      : null;

    if (!track || !thumb || !track.isConnected) {
      return;
    }

    var scrollHeight = body.scrollHeight;
    var clientHeight = body.clientHeight;
    var scrollTop = body.scrollTop;
    var childrenHeight = 0;
    var i;

    /* Skip invalid layouts (detached/rebuilding) so we don't hide a valid track */
    if (clientHeight < 1 || scrollHeight < 1) {
      return;
    }

    for (i = 0; i < body.children.length; i++) {
      childrenHeight += body.children[i].offsetHeight;
    }

    var overflowDiff = Math.max(
      scrollHeight - clientHeight,
      childrenHeight - clientHeight
    );
    var needsScroll = overflowDiff > 1 || scrollTop > 0;

    if (!needsScroll) {
      track.classList.remove('is-active');
      track.removeAttribute('data-cd-active');
      track.removeAttribute('hidden');
      track.style.setProperty('display', 'none', 'important');
      return;
    }

    cdScrollbarSyncToken += 1;
    track.classList.add('is-active');
    track.setAttribute('data-cd-active', 'true');
    track.setAttribute('data-cd-synced', String(cdScrollbarSyncToken));
    track.removeAttribute('hidden');
    track.style.setProperty('display', 'block', 'important');

    var contentHeight = Math.max(scrollHeight, childrenHeight);
    var thumbHeight = Math.max(
      (clientHeight / contentHeight) * clientHeight,
      20
    );
    var maxScroll = Math.max(contentHeight - clientHeight, 1);
    var maxTop = clientHeight - thumbHeight;
    var top = (scrollTop / maxScroll) * maxTop;

    if (top < 0) {
      top = 0;
    }

    if (top > maxTop) {
      top = maxTop;
    }

    thumb.style.height = thumbHeight + 'px';
    thumb.style.transform = 'translateY(' + top + 'px)';
  }

  function syncAllCdScrollbars(reason) {
    var bodies = document.querySelectorAll('.cd-drawer .js-cd-body');

    for (var i = 0; i < bodies.length; i++) {
      syncCdScrollbar(bodies[i], reason || 'syncAll');
    }
  }

  function clearCdScrollbarRefreshTimers() {
    var i;

    for (i = 0; i < cdScrollbarRefreshTimers.length; i++) {
      window.clearTimeout(cdScrollbarRefreshTimers[i]);
    }

    cdScrollbarRefreshTimers = [];
  }

  function scheduleCdScrollbarRefresh(reason) {
    clearCdScrollbarRefreshTimers();
    syncAllCdScrollbars(reason);

    cdScrollbarRefreshTimers.push(window.setTimeout(function () {
      syncAllCdScrollbars(reason + ':50ms');
    }, 50));

    cdScrollbarRefreshTimers.push(window.setTimeout(function () {
      syncAllCdScrollbars(reason + ':250ms');
    }, 250));

    cdScrollbarRefreshTimers.push(window.setTimeout(function () {
      syncAllCdScrollbars(reason + ':600ms');
    }, 600));
  }

  function bindCdScrollbar(body) {
    if (!body) {
      return;
    }

    if (body.dataset.cdScrollbarBound === 'true') {
      return;
    }

    body.dataset.cdScrollbarBound = 'true';
    body.addEventListener('scroll', function () {
      syncCdScrollbar(body, 'scroll');
    }, { passive: true });

    body.addEventListener('touchend', function () {
      syncCdScrollbar(body, 'touchend');
    }, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(function () {
        if (!body.isConnected) {
          observer.disconnect();
          return;
        }

        if (body.clientHeight < 1 || body.scrollHeight < 1) {
          return;
        }

        syncCdScrollbar(body, 'resize-observer');
      });
      observer.observe(body);
    }
  }

  function initCdScrollbars(reason) {
    var bodies = document.querySelectorAll('.cd-drawer .js-cd-body');

    for (var i = 0; i < bodies.length; i++) {
      bindCdScrollbar(bodies[i]);
      syncCdScrollbar(bodies[i], reason || 'init');
    }

    scheduleCdScrollbarRefresh(reason || 'init');
  }

  function watchCartDrawerDomForScrollbar() {
    var container = document.querySelector('.js-cart-drawer-container');

    if (!container || typeof MutationObserver === 'undefined') {
      return;
    }

    if (cdScrollbarMutationObserver) {
      cdScrollbarMutationObserver.disconnect();
    }

    cdScrollbarMutationObserver = new MutationObserver(function () {
      initCdScrollbars('dom-mutation');
    });

    cdScrollbarMutationObserver.observe(container, {
      childList: true,
      subtree: false,
    });
  }

  window.initCdScrollbars = initCdScrollbars;
  window.syncAllCdScrollbars = syncAllCdScrollbars;

  function changeDrawerQuantity(line, qty) {
    if (qty < 0) {
      qty = 0;
    }

    $('.cd-drawer').addClass('loading-icon');

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: JSON.stringify({
        line: line,
        quantity: qty,
      }),
      contentType: 'application/json',
    }).done(function () {
      var selectedPackage = $('.package_wrapper.choosed').attr('data-pack');

      if (selectedPackage) {
        $('[data-pack="' + selectedPackage + '"]').trigger('click');
      }

      if (typeof window.rebuild_cart === 'function') {
        window.rebuild_cart();
      }
    }).fail(function () {
      $('.cd-drawer').removeClass('loading-icon');
    });
  }

  function handleQtyButton($btn) {
    var $wrap = $btn.closest('.js-cd-qty');
    var $input = $wrap.find('.js-cd-qty-input');
    var maxQuantity = parseInt($input.attr('max'), 10);
    var inventoryManagement = $input.attr('inventoryManagement');
    var line = $input.data('line');
    var qtyVal = parseInt($btn.attr('target_quantity'), 10);

    $wrap.removeClass('is-error');
    $wrap.find('.js-cd-qty-error').prop('hidden', true);

    if (
      qtyVal > maxQuantity &&
      maxQuantity !== 0 &&
      inventoryManagement !== ''
    ) {
      qtyVal = maxQuantity;
      $wrap.addClass('is-error');
      $wrap.find('.js-cd-qty-error').prop('hidden', false);
      return;
    }

    $input.val(qtyVal);
    changeDrawerQuantity(line, qtyVal);
  }

  function initCartDrawerCarousel() {
    var $swiperEl = $('.cd-drawer .js-cart-drawer-trending-swiper');

    if (!$swiperEl.length || typeof Swiper === 'undefined') {
      return;
    }

    if (trendingSwiper) {
      trendingSwiper.destroy(true, true);
      trendingSwiper = null;
    }

    var $drawer = $swiperEl.closest('.cd-drawer');

    trendingSwiper = new Swiper($swiperEl[0], {
      slidesPerView: 2.15,
      spaceBetween: 8,
      navigation: {
        nextEl: $drawer.find('.js-cart-drawer-trending-next')[0],
        prevEl: $drawer.find('.js-cart-drawer-trending-prev')[0],
      },
      breakpoints: {
        990: {
          slidesPerView: 2.35,
          spaceBetween: 8,
        },
      },
    });
  }

  window.initCartDrawerCarousel = initCartDrawerCarousel;
  window.resetDrawerItemsHeight = resetDrawerItemsHeight;

  function getCartDrawerSectionId() {
    var drawer = document.querySelector('.cd-drawer');
    if (drawer && drawer.dataset.sectionId) {
      return drawer.dataset.sectionId;
    }
    return 'cart-drawer';
  }

  $(document).on('click', '.cd-drawer .js-cd-cart-remove', function (e) {
    e.preventDefault();

    var line = this.getAttribute('data_line');

    $('.cd-drawer').addClass('loading-icon');

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: JSON.stringify({
        line: line,
        quantity: 0,
      }),
      contentType: 'application/json',
    }).done(function () {
      var selectedPackage = $('.package_wrapper.choosed').attr('data-pack');

      if (selectedPackage) {
        $('[data-pack="' + selectedPackage + '"]').trigger('click');
      }

      if (typeof window.rebuild_cart === 'function') {
        window.rebuild_cart();
      }

      if (typeof remove_luxury_package === 'function') {
        remove_luxury_package();
      }
    }).fail(function () {
      $('.cd-drawer').removeClass('loading-icon');
    });
  });

  $(document).on('click', '.cd-drawer .js-cd-qty-minus, .cd-drawer .js-cd-qty-plus', function (e) {
    e.preventDefault();
    handleQtyButton($(this));
  });

  $(document).on('change', '.cd-drawer .js-cd-qty-input', function () {
    var $input = $(this);
    var $wrap = $input.closest('.js-cd-qty');
    var maxQuantity = parseInt($input.attr('max'), 10);
    var line = $input.data('line');
    var qtyVal = parseInt($input.val(), 10);

    if (isNaN(qtyVal)) {
      qtyVal = 0;
    }

    if (qtyVal > maxQuantity && maxQuantity !== 0) {
      qtyVal = maxQuantity;
    }

    $input.val(qtyVal);
    $wrap.removeClass('is-error');
    changeDrawerQuantity(line, qtyVal);
  });

  $(document).ready(function () {
    watchCartDrawerState();
    watchCartDrawerDomForScrollbar();
    resetDrawerItemsHeight();
    initCartDrawerCarousel();
    initCdScrollbars('dom-ready');
    syncCartCountFromApi();
    updateFreeShippingHtml();
  });

  $(window).on('resize', function () {
    syncAllCdScrollbars('resize');
  });

  $(document).ajaxComplete(function (_event, xhr, settings) {
    var url = settings.url || '';
    var sectionId = getCartDrawerSectionId();

    if (
      url.indexOf('section_id=' + sectionId) === -1 &&
      url.indexOf('section_id=cart-drawer') === -1
    ) {
      return;
    }

    var cartCounterText = $('<div>').html(xhr.responseText).find('.item-counter').text();

    if (cartCounterText !== '') {
      syncCartDrawerCount(cartCounterText);
    } else {
      syncCartCountFromApi();
    }
  });

  $(document).on('cart:drawer:updated', function () {
    resetDrawerItemsHeight();
    initCartDrawerCarousel();
    initCdScrollbars('cart:drawer:updated');
    updateFreeShippingHtml();
  });
})(jQuery);
